export * from './extra-vereinbarung-gespeichert.interface';
